module.exports = __webpack_public_path__ + "img/athletics_icon_13.5feb116f.png";